import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import DashboardErrorContainer from '../dashboard-error-container'
import DashboardLoadingContainer from '../dashboard-loading-container'
import DashboardEnrollFailedContainer from '../dashboard-enroll-failed-container'
import DashboardSuccessContainer from '../dashboard-success-container'
import { performPaymentValidation } from '../../../../redux/actions/validate'
import { retrieveUserCompanies } from '../../../../redux/actions/user'
import { auth } from '../../../../networking/firebase'
import './style.scss'

const Index = props => {

    const dispatch = useDispatch()

    const callbackId = props.match.params.id

    const error = useSelector(state => state.validate.processError)
    const loading = useSelector(state => state.validate.processLoading) 
    const status = useSelector(state => state.validate.processStatus)

    const [firstLoad, setFirstLoad] = useState(false)

    useEffect(() => {

        if(callbackId && callbackId !== "feil" && !firstLoad){
            setFirstLoad(true)
            fetch(`/api/stripe/checkout-session?sessionId=${callbackId}`).then((result) => {
                return result.json()
            }).then((session) => {
                if(session.payment_status === "paid"){
                    dispatch(performPaymentValidation({
                        companyId: session.metadata.companyId,
                        customerId: session.customer,
                        subscriptionId: session.subscription,
                        sessionId: session.id,
                        amount: session.amount_total,
                        timestamp: moment(Date.now()).unix()
                    }))
                }
            })
        }

        if(status){
            dispatch(retrieveUserCompanies(auth.currentUser.uid))
        }

    }, [callbackId, error, status, loading])

    const renderContent = () => {
        if(callbackId === "feil"){
            return <DashboardErrorContainer/>
        } else {
            if(loading){
                return <DashboardLoadingContainer/>
            } else if(error){
                return <DashboardEnrollFailedContainer/>
            } else if(status){
                return <DashboardSuccessContainer/>
            } else {
                return <DashboardLoadingContainer/>
            }
        }
    }

    return(
        <section className="dashboard-validate-section">
			<div className="inner-dashboard-validate-container">
                {renderContent()}
			</div>
		</section>
    )
}

export default withRouter(Index)